enum FacilityType {
  Industrial = 'Industrial',
  Retail = 'Retail',
  SelfStorage = 'Self Storage',
  Multifamily = 'Multifamily',
  DataCenter = 'Data Center',
  Office = 'Office',
  Hotel = 'Hotel',
  LifeScience = 'Life Science',
  Other = 'Other',
}

export default FacilityType;
